'use client';

import React, {useEffect, useState} from 'react';

export function ConfigBootstrap({ children }: { children: React.ReactNode }) {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    async function loadConfig() {
      try {
        const response = await fetch('/api/config');
        if (response.ok) {
          (window as any).__RUNTIME_CONFIG__ = await response.json();
        } else {
          console.warn('Config API returned an error, falling back to build-time envs');
        }
      } catch (error) {
        // No Tauri ou SSG, o fetch para /api/config vai falhar
        console.info('Config API not available, using build-time envs');
      } finally {
        setIsReady(true);
      }
    }

    loadConfig();
  }, []);

  if (!isReady) {
    // Você pode retornar um loading spinner aqui se quiser que a app espere as configs
    return null;
  }

  return <>{children}</>;
}
